import React from 'react';
import { Form } from 'react-final-form';
import { connect } from 'react-redux';
import ForgotPasswordForm from '../../components/auth/ForgotPasswordForm.jsx';
import { mapFinalFormErrors } from '../../lib/utils.js';
import { resetPassword } from '../../modules/auth.js';

const mapDispatch = { resetPassword };

const mapErrors = mapFinalFormErrors('Failed to request password reset.');

const onSubmit = (resetPassword) => (values) =>
  resetPassword(values)
    .then(() => undefined)
    .catch(mapErrors);

const validate = (values) => {
  const errors = {};

  if (!values.email) {
    errors.email = 'Email is required';
  }

  return errors;
};

function ForgotPasswordFormContainer({ resetPassword }) {
  return (
    <Form
      component={ForgotPasswordForm}
      onSubmit={onSubmit(resetPassword)}
      validate={validate}
    />
  );
}

export default connect(null, mapDispatch)(ForgotPasswordFormContainer);
